import type { Category } from "@/types/article";

// MVP: 6 categories, no fallback.
export const V2_CATEGORIES = [
  "sverige",
  "varlden",
  "politik",
  "ekonomi",
  "sport",
  "noje",
] as const;

export type V2Category = (typeof V2_CATEGORIES)[number];

export const V2_CATEGORY_LABELS: Record<V2Category, string> = {
  sverige: "Sverige",
  varlden: "Världen",
  politik: "Politik",
  ekonomi: "Ekonomi",
  sport: "Sport",
  noje: "Nöje",
};

export function isV2Category(value: string | undefined): value is V2Category {
  return !!value && (V2_CATEGORIES as readonly string[]).includes(value);
}

export function labelFor(cat: Category | V2Category | string): string {
  return (V2_CATEGORY_LABELS as Record<string, string>)[cat] ?? cat;
}